module.exports = __webpack_public_path__ + "static/media/petrichor.d4b9cd04.jpeg";